'use client'

import { searchEvents } from '@/actions/event'
import ChevronDown from '@/components/icons/chevron-down'
import ChevronLeft from '@/components/icons/chevron-left'
import ChevronRightIcon from '@/components/icons/chevron-right'
import dayjs from '@/lib/dayjs'
import { useEffect, useState } from 'react'
import DriverCalendarMonth from './driver-calendar-month'
import DriverCalendarWeek from './driver-calendar-week'

export default function CalendarView({ session }) {
  const weekdayOffset = 1 // Monday start of week
  const [mode, setMode] = useState('weekly')
  const [week, setWeek] = useState(weekdayOffset)
  const [monthIndex, setMonthIndex] = useState(dayjs().month())
  const [month, setMonth] = useState(dayjs().startOf('month'))

  const [events, setEvents] = useState([])
  const [eventsLoading, setEventsLoading] = useState(false)

  useEffect(() => {
    async function fetchEvents() {
      setEventsLoading(true)

      const results = await searchEvents({
        where: {
          attendees: {
            some: {
              userId: session.user.id,
            },
          },
          championship: {
            deleteTs: null,
          },
        },
        include: {
          championship: {
            include: {
              community: true,
              game: true,
              platforms: {
                select: {
                  platform: true,
                },
              },
              carClasses: {
                include: {
                  carClass: true,
                },
              },
            },
          },
          sessions: {
            orderBy: {
              targetDateTime: 'asc',
            },
          },
          attendees: {
            where: {
              status: 'registered',
            },
            select: { userId: true, status: true, role: true, user: true },
            distinct: ['userId'],
          },
        },
      })

      setEvents(results)
      setEventsLoading(false)
    }

    fetchEvents()
  }, [session.user.id])

  return (
    <div className="col-span-full">
      <div className="flex w-full items-center justify-between">
        <div className="flex w-full flex-col lg:flex-row">
          <div className="flex w-full justify-between">
            <h4 className="self-center text-h-5 font-semibold lg:text-h-4">
              My Race Calendar
            </h4>

            {/* weekly monthly selector */}
            <div
              className="flex cursor-pointer items-center gap-2 self-center rounded-full bg-neutral-blue-700 px-4 py-2 text-p-2 font-bold capitalize lg:mr-4 lg:px-6 lg:py-4"
              onClick={() => setMode(mode === 'weekly' ? 'monthly' : 'weekly')}
            >
              <p>{mode}</p>
              <ChevronDown className="stroke-3 size-4 stroke-shades-0" />
            </div>
          </div>
          <div className="mt-4 flex w-full items-center gap-3 lg:mt-0 lg:w-max">
            {/* time scroller */}
            <div className="flex w-full items-center justify-between gap-2 rounded-full bg-neutral-blue-700 px-6 py-4 text-p-2 font-bold capitalize lg:w-max">
              <ChevronLeft
                className="stroke-3 size-4 cursor-pointer stroke-shades-0"
                onClick={() => {
                  if (mode === 'weekly') {
                    setWeek(week - 7)
                  } else {
                    setMonthIndex(monthIndex - 1)
                    setMonth(month.subtract(1, 'month'))
                  }
                }}
              />
              <p>
                {mode === 'weekly'
                  ? dayjs().weekday(week).format('ddd DD MMM')
                  : month.format('ddd DD MMM')}{' '}
                -{' '}
                {mode === 'weekly'
                  ? dayjs()
                      .weekday(week + 6)
                      .format('ddd DD MMM ')
                  : month.endOf('month').format('ddd DD MMM ')}
                <span className="text-neutral-blue-500">
                  {mode === 'weekly'
                    ? dayjs()
                        .weekday(week + 6)
                        .format('YYYY')
                    : month.endOf('month').format('YYYY')}
                </span>
              </p>
              <ChevronRightIcon
                className="stroke-3 size-4 cursor-pointer stroke-shades-0"
                onClick={() => {
                  if (mode === 'weekly') {
                    setWeek(week + 7)
                  } else {
                    setMonthIndex(monthIndex + 1)
                    setMonth(month.add(1, 'month'))
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {eventsLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          {mode === 'weekly' ? (
            <DriverCalendarWeek
              events={events}
              weekBeginning={week}
              session={session}
            />
          ) : (
            <DriverCalendarMonth
              events={events}
              session={session}
              monthIndex={monthIndex}
              month={month}
            />
          )}
        </>
      )}
    </div>
  )
}
